import { getDropdownItemsFromStatusConfig } from 'shared/ui/Status'
import { subscriptionStatusConfig } from 'entities/Subscription/ui/Status/config'

export const subscriptionsStatusDropdownItems =
  getDropdownItemsFromStatusConfig(subscriptionStatusConfig)
